import React from "react";
import { Workflow } from "@/types/workflow";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Play, ChevronDown, Loader2 } from "lucide-react";

interface StartWorkflowButtonProps {
  workflows: Workflow[];
  onStartWorkflow: (workflowId: string) => void;
  isLoading: boolean;
}

export const StartWorkflowButton: React.FC<StartWorkflowButtonProps> = ({
  workflows,
  onStartWorkflow,
  isLoading,
}) => {
  const activeWorkflows = workflows.filter(w => w.is_active);

  if (workflows.length === 0) {
    return (
      <Button disabled variant="outline">
        <Play className="h-4 w-4 mr-2" />
        Geen workflows
      </Button>
    );
  }

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button disabled={isLoading}>
          {isLoading ? (
            <Loader2 className="h-4 w-4 mr-2 animate-spin" />
          ) : (
            <Play className="h-4 w-4 mr-2" />
          )}
          Start Workflow
          <ChevronDown className="h-4 w-4 ml-2" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-56">
        {workflows.map((workflow) => (
          <DropdownMenuItem
            key={workflow.id}
            onClick={() => onStartWorkflow(workflow.id)}
            disabled={!workflow.is_active}
            className="cursor-pointer"
          >
            <div className="flex items-center gap-2 w-full">
              <div
                className={`h-2 w-2 rounded-full ${
                  workflow.is_active ? "bg-green-500" : "bg-gray-400"
                }`}
              />
              <span className="truncate flex-1">{workflow.name}</span>
              {!workflow.is_active && (
                <span className="text-xs text-muted-foreground">(inactief)</span>
              )}
            </div>
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
